import { render, staticRenderFns } from "./partnersPanel.vue?vue&type=template&id=0645f8f1&"
import script from "./partnersPanel.vue?vue&type=script&lang=js&"
export * from "./partnersPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports